require('../js/dropzone.js');

function initializeDropzone() {
    var csrf_token = document.getElementById('csrf_token').value;
    var dropZoneInput = document.getElementById('file-uploader-dropzone');
    console.log('initializing dropzone');

    $('div#file-uploader-dropzone').dropzone({
        url: '/conversion/text',
        params: {
            _token: csrf_token,
            email: 'guest',
            doctype: 'resume',
            raw_doc: typeof variable !== 'undefined' ? raw_doc : false,
            id: 0,
        },
        method: 'post',
        maxFiles: 1,
        acceptedFiles: '.doc,.docx,.pdf,.fodt,.odt,.rtf,.txt',
        maxFilesize: 5,
        addRemoveLinks: false,
        createImageThumbnails: false,
        previewTemplate: '<span></span>',
        complete: function() {
            this.removeAllFiles();
        },
        addedfile: function(file) {
            $('#step1-title').html('<i class="fa fa-spinner fa-pulse fa-fw"></i>');
            $('.upload-disabled').css('color', 'darkgray');
            if (file.size > 5000000) {
                showNotify(
                    'Your resume file size is too large. Limit your file size to under 5MB to avoid ATS parsing issues.',
                    'error'
                );
            } else if (file.size > 4000000) {
                showNotify(
                    'Your resume file size is large. Consider reducing image sizes or large graphics in your resume to avoid ATS parsing issues.',
                    'warning'
                );
            }
        },
        success: function(file, response) {
            if (response.errors) {
                showNotify(
                    'Type of document or encoding not supported. Please try a different document or paste your document instead.',
                    'error'
                );
            } else {
                let jsonResult = typeof response === 'string' ? JSON.parse(response) : response;
                $('#step1-title').html('');
                $('.upload-disabled').css('color', 'inherit');
                $('#cv')
                    .val(jsonResult['text'])
                    .change();
                $('#path_info').val(jsonResult['path']);
                $('<input>')
                    .attr({
                        type: 'hidden',
                        id: 'conversion_id',
                        name: 'conversion_id',
                        value: jsonResult['conversion_id'],
                    })
                    .appendTo('#cvjd');
                mixpanel.track('[Results Page] - Uploaded Resume', {
                    id: 0,
                    type: 'guest',
                });
                if (jsonResult['message']) {
                    showNotify(jsonResult['message'], 'warning');
                }

                if (jsonResult['message'] == null) {
                    if (jsonResult['name'].toLowerCase().indexOf('.docx') >= 0) {
                        $('#btnAnalyze_powerEdit').removeClass('disabled');
                        showNotify('Resume upload successful and resume format processed!', 'success');
                    } else {
                        showNotify('Resume upload successful!', "success");
                    }
                }
            }
        },
        error: function(file, response) {
            showNotify(
                'There was an error with your upload, please try to paste your resume instead.',
                'error'
            );
            $('#step1-title').html('');
            $('.dz-message').css('color', '#2aacea');
            $('.upload-disabled').css('color', 'inherit');
        },
    });

    function checkMasterCvChange() {
        if ($('#cv').val() != $('#cv_hidden_master').val()) {
            $('#master_cv').prop('checked', false);
            $('#master_cv').attr('checked', false);
        }
    }

    mixpanel.track('[Main Page] - Landed', {
        id: '0',
        type: 'guest',
    });

    $('.dz-message').click(function(e) {
        e.preventDefault();
        //do other stuff when a click happens
    });

    $('.upload-disabled').click(function(e) {
        e.preventDefault();
        //do other stuff when a click happens
    });

    var client_id = localStorage.getItem('client-id');
    $('#client-id').val(client_id);

    $('#clearCv').click(function() {
        sessionStorage.cv = '';
        $('#cv').val('');
        mixpanel.track('[Main Page] - Clear Resume', {
            id: "{{ (Auth::user())?Auth::user()->id:'0' }}",
            type:
                "{{ (Auth::user())?((Auth::check() && Auth::user()->isPremiumUser())?'premium':'standard'):'guest' }}",
        });
        return false;
    });

    $('#clearJd').click(function() {
        sessionStorage.jd = '';
        $('#jd').val('');
        mixpanel.track('[Main Page] - Clear Job Description', {
            id: "{{ (Auth::user())?Auth::user()->id:'0' }}",
            type:
                "{{ (Auth::user())?((Auth::check() && Auth::user()->isPremiumUser())?'premium':'standard'):'guest' }}",
        });
        return false;
    });

    $('#btnAnalyze').click(function() {
        var client_id = localStorage.getItem('client-id');
        $('#client-id').val(client_id);
        $('#step1-title-error').fadeOut('slow');
        checkMasterCvChange();
        if ($('#cv').val().length < 100 || $('#jd').val().length < 100) {
            if ($('#cv').val().length < 100) {
                showNotify('Please enter a resume before scanning.', 'error');
            } else if ($('#jd').val().length < 100) {
                showNotify('Please enter a job description before scanning.', 'error');
            }
            return false;
        }

        storeCvJd();

        mixpanel.track('[Main Page] - Scanned Resume', {
            'click-source': "{{ (isset($master_cv))?'master_cv':'' }}",
            id: "{{ (Auth::user())?Auth::user()->id:'0' }}",
            type:
                "{{ (Auth::user())?((Auth::check() && Auth::user()->isPremiumUser())?'premium':'standard'):'guest' }}",
        });

        $('#btnAnalyze').html('Scanning...');
    });

    $('#trySampleCta').click(function() {
        mixpanel.track('[Main Page] - Try Sample Resume', {
            id: "{{ (Auth::user())?Auth::user()->id:'0' }}",
            'click-source': 'topCTA',
            type:
                "{{ (Auth::user())?((Auth::check() && Auth::user()->isPremiumUser())?'premium':'standard'):'guest' }}",
        });

        trySample(false);
    });

    $('#trySample').click(function() {
        mixpanel.track('[Main Page] - Try Sample Resume', {
            id: "{{ (Auth::user())?Auth::user()->id:'0' }}",
            'click-source': 'bottomCTA',
            type:
                "{{ (Auth::user())?((Auth::check() && Auth::user()->isPremiumUser())?'premium':'standard'):'guest' }}",
        });

        trySample(false);
    });

    function storeCvJd() {
        if ($('#cv').val() != '') {
            // localStorage.cv = $('#cv').val();
            sessionStorage.cv = $('#cv').val();
        }
        if ($('#jd').val() != '') {
            // localStorage.jd = $('#jd').val();
            sessionStorage.jd = $('#jd').val();
        }
    }

    function restoreCvJd() {
        if (sessionStorage.cv && $('#cv').val() == '') {
            $('#cv').val(sessionStorage.cv);
        }
        if (sessionStorage.jd && $('#jd').val() == '') {
            $('#jd').val(sessionStorage.jd);
        }
    }

    function trySample(scroll) {
        $('html, body').animate({ scrollTop: $('#cvJdSection').offset().top }, 250);
        $('#cv').val('');
        $('#jd').val('');
        setTimeout("$('#cv').focus()", 333);
        setTimeout("$('.cvCol > h3').css('font-weight', 600)", 333);
        setTimeout(
            `$('#cv').val("An accomplished Product Management team player with extensive and diversified management experience in defining and delivering successful consumer and enterprise software products to meet market needs. In-depth knowledge of product-life-cycle management, business development, and leading cross-functional teams. Excellent domain knowledge in Mobile platforms, Online Commerce, Mobile commerce, Mobile Shopping and Web applications, Navigation and Location Based Services, Software as a Service (SaaS), and Enterprise Security products.A self-starter with a proven ability to manage multiple products and projects.Work ExperienceSenior Product Manager Good Technology April 2011 to November 2013 Responsible for roadmap strategy and delivery of Good's flagship product, Good for Enterprise, which provides security and management to application data and devices. It has allowed enterprises and government sectors to manage and deploy a secure collaboration solution to millions of mobile devices.Drive requirements definition, development, and multi-platform support of user-valued features on iPhone iOS, and Windows devices.Delivered successful products requiring close internal and external partnership collaborations, including with mobile OEMs, ISV, and online services.Led the development and innovation teams based in the US, Sunnyvale, and Poland as the Product Owner in an agile environment to consistently deliver high-quality products for the iPhone iOS, and Windows platforms.Increased the number of iOS user base by a factor of 5X all with good customer experience feedback Conceived and led the creation of Good for Enterprise on Windows Phone 7.5, Windows Phone 8, and Windows 8 tablets Senior Product Manager FileMaker, Inc February 2010 to October 2010 Successfully launched FileMaker Go 1.0 for iPad, becoming the #1 Paid Business app and #1 Business Grossing app in the first week. It received 4 out of 5 mice from MacWorld.Coordinate, facilitate, and manage a team through two cycles of product launches.Provide features recommendations and product roadmap to senior executives based on market segment, customer experience and feedback, competitive analysis, and market research.Conduct usability studies on existing products to identify areas of improvement.Manage a group of external beta testers to help find bugs and issues.Collaborate with Product Marketing to create product messaging and web content to promote FileMaker Go.Conduct product usage survey and provide Product Requirements Documents summary and recommendations related to the next version of products to senior executives.Participate in web seminars with existing and new customers to present and answer questions on FileMaker Go.Develop a product demo that was delivered to over one thousand attendees at FileMaker Developer's Conference.Senior Product Manager TeleNav Inc September 2007 to February 2010 In charge of creating MRD and UI flow documents based on internal and external requirements to guide engineering's development of TeleNav and white label branded mobile products.Designed and launched AT&T Navigator, a white labeled turn-by-turn navigation product for AT&T, on BlackBerry, Windows Mobile, Symbian and J2ME devices.Designed and launched TeleNav GPS Navigator on T-Mobile G1, the first turn by turn navigation application on the Windows mobile platform.Designed and launched YellowPages Mobile application, a business search and mapping application, on J2ME devices.Develop product roadmap for TeleNav GPS Navigator and white label solution products.Providing product management support to Alltel, Rogers, Bell Canada and Sprint carriers.Conduct usability testing on new or existing products to find areas of improvement.Host Customer Advisory Board to better understand issues reported by customers of TeleNav.Product Manager Palm Inc July 2005 to September 2007 Launched a carrier grade OTA backup solution for Treo smartphones.Lead the product development lifecycle from initial concept to market launch.Worked with engineering to develop the backup solution on a SyncML platform.Responsible for the marketing and functional specifications for an Enterprise service strategy, involving remote file access, kill pill and device management on Treo.Identify unmet smartphone customer needs through market research and analysis.Define and document product/service requirements and functional definitions based on identified target customer needs.Work with Engineering, Marketing, Sales and Support to prioritize product features.Identify and assist in selecting partners to deliver competitive and interoperable solutions.Establish the business case, financial model and pricing to justify investment in a service offering.Work with business development to outline and negotiate desired partnership business terms.Establish metrics to measure usage and success factors of deployed services.Proactively seek market feedback on deployed services and develop a detailed feature roadmap.Ensure product plans include end-user needs, carrier requirements, competition and industry standards.Technical Support Engineer Akamai Technology May 2004 to July 2005 Troubleshooting and resolving technical issues for customer during pre and post-sale cycles. Provide Operational Support to customers.Perform system analysis using Perl, UNIX commands, and network tracing tools to identify and resolve customer issues to meet high standards customer experience ratings.Lead the delivery of support and relationship management with designated Premium accounts, such as Macys, Yahoo, and Internet Broadcasting Service.Develop knowledge base and best practices for the Technical Support team to troubleshoot Windows Media service and Flash streaming service on the Akamai network.Worked with Engineering on ensuring supportability of new Akamai services by having proper documentation and knowledge transfer to the support organization.Respond to customer issues and questions through phone and email.Participate in weekly conference calls with Premium account customers to review support issues and tickets.Software Engineer Yodlee Inc September 1999 to May 2003 Created a scaled down version of the company's web application for cell phones by using Perl scripts to generate HDML and WML pages for the different kinds of mobile devices and to interface with the backend core application for accessing data.Created and maintained Perl scripts to customize the look and behavior of Yodlee's data aggregation Web app for large financial institutions.Involved in the next generation of Yodlee's core product design and implementation, using J2EE and Websphere. Ported applications written in Perl to Java. Wrote technical manuals for the customers.Various duties in supporting the QA, marketing, customer service teams by reviewing test procedures, generating statistical reports, and troubleshooting production issues.IT Specialist IBM July 1997 to September 1999 Developed and maintained a data collection system written in C for collecting disk manufacturing data from the assembly line and capture that information in a DB2 database.Developed and maintained a business report system which runs database queries to extract and analyze sales information a daily basis.Member of a development team who developed a Lotus Notes application for purchase approval, record tracking, and other manufacturing related business processes.Member of a development and innovation team who implemented a web based tracking system for dealing RMD products. Developed the system using HTML, Java servlets, JDBC, and DB2.EducationB.S. in Computer Science University of California - San Diego, CA 1997. 98133 Contact Informationtest201@gmail.com215.534.7202DENVER, CO 80210")`,
            667
        );
        setTimeout("$('.cvCol > h3').css('font-weight', 400)", 1000);
        setTimeout("$('#jd').focus()", 1000);
        setTimeout("$('.jdCol > h3').css('font-weight', 600)", 1000);
        setTimeout(
            `$('#jd').val("Mobile Shopping is one of Amazon’s fastest growing new businesses.The Mobile team builds world-class customer experiences in all Amazon countries.Focused on mobile commerce, the team supports mobile browser experiences across platforms and shopping applications (apps) on high technology devices including BlackBerry, Android phones, Apple devices, Windows Phone 7, and Android tablets.Role Summary: We’re looking for a senior product manager to lead a team of product managers focused on engagement across all mobile platforms and the phone application platforms (e.g. iPhone, Android, and Windows Phone). Although the primary execution focus of this role is on the phone applications, the mobile team is a multi-platform, global organization and the senior product manager will be expected to lead strategic thinking, innovation, and initiatives that extend across the entire organization. Traits that are not unique to this position, but necessary for Amazon leaders:• Exhibits excellent judgment• Hires and develops great people• Has relentlessly high standards (is never satisfied with the status quo) • Dives deep and is never out of touch with the details of the business • Expects and requires innovation of her/his team• Strong bias for action and delivery of results• Thinks big Role Responsibilities: As the Senior Product Manager, you and your team’s key responsibilities will include:• Understanding the worldwide mobile market including the size of the global opportunities and the competitive landscape• Building forecasts that set aggressive goals for the worldwide platform and managing the platform to results in line with those goals• Sweating the small stuff when it comes to the customer experience and your business. Your product management team will be the foremost experts on all client and business aspects of this platform· Being conversant in the technology.· Writing lightweight product requirements documents and ensuring clear understanding of these requirements to the business, design, and development teams · Managing priorities and trade-offs among customer experience, site performance and support load· Leading detailed execution of features ensuring a high quality bar, timely delivery , and an keen to detail· Proactively identifying and fixing issues that may impair the team’s ability to meet strategic, financial, and technical goals· Leading across the organization to ensure we implement ourgoals efficiently Basic Qualifications• 5-7+ years product management experience in a technological industry • 3+ years experience in consumer-facing mobile commerce and/or wireless content or mobile services")`,
            1333
        );
        setTimeout("$('.jdCol > h3').css('font-weight', 400)", 1500);
        setTimeout("$('#btnAnalyze').focus()", 1500);
        setTimeout("$('#btnAnalyze').css('font-weight', 700)", 1500);
        setTimeout("$('#btnAnalyze').click()", 1500);
    }

    // var utm_source = getUrlParameter('utm_source', window.location.search);
    // if (utm_source == "cjaffiliate") {
    //     setCookie("cjaffiliate", "cjaffiliate");
    // }

    $('#close-error').click(function() {
        $('#error-message-div').hide();
    });
    $('#close-success').click(function() {
        $('#success-message-div').hide();
    });

    $('ul.nav .dropdown').hover(
        function() {
            $(this)
                .find('.dropdown-menu')
                .stop(true, true)
                .fadeIn(500);
        },
        function() {
            $(this)
                .find('.dropdown-menu')
                .stop(true, true)
                .fadeOut(500);
        }
    );
}
initializeDropzone();
